import { DateTime } from '@/modules/shared/schemas/DateTime'

import { TicketRepository } from '../repositories/TicketRepository'

export function ListPatientTicketsCase(ticketRepository: TicketRepository) {
  return async function ({
    patientId,
    date
  }: {
    patientId: string
    date: DateTime
  }) {
    return await ticketRepository.listTicketsPatient({ patientId, date })
  }
}
